/**
 * Skeleton — shimmer placeholder. Replaces inline animate-pulse divs.
 */

import { cn } from '../../lib/utils';

export default function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-lg',
        'bg-neutral-200 dark:bg-neutral-800',
        "after:absolute after:inset-0",
        "after:bg-gradient-to-r after:from-transparent after:via-white/30 dark:after:via-white/10 after:to-transparent",
        "after:animate-[shimmer_2s_infinite] after:bg-[length:200%_100%]",
        className
      )}
      aria-hidden="true"
      {...props}
    />
  );
}
